import React from "react";

function Footer (){
   let codeEffect = "</>"
return(

 
  <section className="h-full w-full flex flex-col bg-neutral-900">
      <div className=" py-3">
        <p className="text-indigo-700 text-xl font-accent text-center">{codeEffect}</p>
          <p className="mt-2 font-accent text-base leading-6 text-center text-indigo-500">
          built by & photo©2023 Sophie Perks.
          </p>
      </div>
      
  </section>

)




}

export default Footer;